import { z } from "zod";

export const getVehiclesListQuerySchema = z.object({
  companyUuid: z.uuid().optional(),
  departmentUuid: z.uuid().optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
});

export type GetVehiclesListQuery = z.infer<typeof getVehiclesListQuerySchema>;
